import { Button, Popup, TextBox } from 'devextreme-react';
import { useRef } from 'react';
import { useEditor } from '.';
import { MODEL } from '../../../constants/models';
import { useAPI } from '../../../store';
import { Container } from './Components';
import { getResult, notification } from './utils';
import axios from 'axios';

export const Toolbar = () => {
  const api = useAPI();
  const confirmRef = useRef();
  const {
    isPreviewing,
    setIsPreviewing,
    keyValues,
    template,
    setTemplate,
    update,
    previewRef,
    setPreviewImage,
    setPrinting,
    size,
  } = useEditor();

  const handleSave = async () => {
    return await (template._id ? api.updateById : api.create)(MODEL.TEMPLATE, template).then((data) => {
      notification('Plantilla guardada', 'success');
      return data;
    });
  };

  const handleDelete = async () => {
    if (template?._id) {
      await api.deleteMany(MODEL.TEMPLATE, [template._id]);
    }
    setTemplate();
  };

  const handleDownload = async () => {
    const base64 = await getResult(previewRef.current, size);

    if (!base64) return;
    var a = document.createElement('a');
    a.href = base64;
    a.download = `${template.name}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const previewPrinting = async () => {
    const image = await getResult(previewRef.current, size);
    setPreviewImage(image);
    setPrinting(true);
  };

  return (
    <>
      <Container style={{ borderBottom: '1px solid #ccc' }}>
        <Button hint="Atrás" type="normal" icon="chevronleft" onClick={() => setTemplate()} />
        <TextBox label="Nombre" value={template.name} onValueChange={(value) => update('name', value)} />
        <Button hint="Guardar" type="default" icon="save" onClick={handleSave} />
        <Button hint="Imprimir" icon="print" onClick={previewPrinting} />
        <Button hint="Descargar" icon="download" onClick={handleDownload} />
        <Button
          text={isPreviewing ? 'Editor' : 'Previsualizar'}
          icon="textdocument"
          onClick={(e) => {
            if (!isPreviewing) {
              e.component.option('disabled', true);
              axios
                .post('/template/preview', {
                  template,
                  keyValues,
                })
                .then((x) => {
                  setIsPreviewing(true);
                  setPreviewImage(x.data.result);
                })
                .finally(() => {
                  e.component.option('disabled', false);
                });
            } else {
              setIsPreviewing(false);
              setPreviewImage(null);
            }
          }}
        />
        <Button
          hint="Eliminar"
          type="danger"
          stylingMode="outlined"
          icon="trash"
          style={{ marginLeft: 'auto' }}
          onClick={() => confirmRef.current.instance.option('visible', true)}
        />
      </Container>
      <Popup
        ref={confirmRef}
        title="Eliminar"
        height={'auto'}
        width={'auto'}
        toolbarItems={[
          {
            widget: 'dxButton',
            toolbar: 'bottom',
            location: 'center',
            options: {
              text: 'Aceptar',
              stylingMode: 'outlined',
              type: 'danger',
              onClick: handleDelete,
            },
          },
        ]}
      >
        ¿Realmente desea eliminar la plantilla?
      </Popup>
    </>
  );
};
